import { defineMailTemplate } from '@adornis/mails/db/mail-template-definition.js';
import {
  getMentorAndMenteeMailVariableData,
  getMentorAndMenteeMailVariables,
  MailTemplateType,
} from '../entities/mail-templates.js';

export function registerFreeForm() {
  return defineMailTemplate(MailTemplateType.FREE_FORM, {
    getMailData: getMentorAndMenteeMailVariableData,
    defaultTemplate: {
      subject: ``,
      content: ``,
      footer: '',
    },
    variables: getMentorAndMenteeMailVariables(),
    attachments: [],
    displayName: 'Freie Mail',
    editorHint: () => 'Diese Mail kann frei verwendet werden',
  });
}
